/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoCrazyGamesLoginOptions, FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoCrazyGamesLoginOptionsFromJSONTyped, FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoCrazyGamesLoginOptionsToJSON, } from './FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoCrazyGamesLoginOptions';
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestCrazyGamesFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestCrazyGamesFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestCrazyGamesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoCrazyGamesLoginOptions(json)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoCrazyGamesLoginOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestCrazyGamesToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestCrazyGamesToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestCrazyGamesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoCrazyGamesLoginOptions(value)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoCrazyGamesLoginOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromSocialRequestCrazyGames.js.map